import { $, $$, isMobile, isTablet, isDesktop, isDesktopLarge, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, FreeMode, A11y } from 'swiper/modules';
import dataLayerPushSlider from '@utils/dataLayerPushSlider';

function init() {
  if (!$('[data-au-benefits]')) return;

  setCardCountClasses();
  initSliders();
  isTablet.addEventListener('change', () => initSliders());
  isDesktop.addEventListener('change', () => initSliders());
  isMobile.addEventListener('change', () => initSliders());
  isDesktopLarge.addEventListener('change', () => initSliders());
}

const cardCountNames = { 2: 'two', 3: 'three', 4: 'four', 5: 'five' };

function setCardCountClasses() {
  $$('[data-au-benefits]').forEach((benefitsEl) => {
    const slidesCount = benefitsEl.querySelectorAll('.swiper-slide').length;
    const name = cardCountNames[slidesCount];
    if (name) benefitsEl.classList.add(`au-benefits--${name}-cards`);
  });
}

function initSliders() {
  $$('[data-au-benefits-slider]').forEach((slider) => {
    const benefitsEl = slider.closest('[data-au-benefits]');
    const isTwoColumns = benefitsEl.hasAttribute('data-au-benefits-two-columns');
    const isAsymmetric = benefitsEl.classList.contains('au-benefits--asymmetric');
    const slidesCount = slider.querySelectorAll('.swiper-slide').length;
    const shouldCreate = isTwoColumns
      ? isMobile.matches
        ? slidesCount > 1
        : isTablet.matches
          ? slidesCount > 2
          : isDesktop.matches
            ? slidesCount > 1
            : slidesCount > 2
      : isMobile.matches
        ? slidesCount > 1
        : isTablet.matches
          ? slidesCount > 2
          : isAsymmetric && isDesktopLarge.matches
            ? slidesCount > 2
            : slidesCount > 3;

    if (shouldCreate) {
      createSwiper(slider);
      benefitsEl.classList.remove('au-benefits--no-slider');
    } else {
      destroySwiper(slider);
      benefitsEl.classList.add('au-benefits--no-slider');
    }
  });
}

function createSwiper(sliderEl) {
  if (sliderEl._swiper) return;

  const swiper = new Swiper(sliderEl, {
    modules: [Navigation, Scrollbar, FreeMode, A11y],
    ...sliderConfig,
    freeMode: false,
    on: {
      init() {
        updateSliderFades(this);
      },
      slideChange() {
        updateSliderFades(this);
      },
      setTranslate() {
        updateSliderFades(this);
      },
      reachBeginning() {
        updateSliderFades(this);
      },
      reachEnd() {
        updateSliderFades(this);
      },
      fromEdge() {
        updateSliderFades(this);
      },
      resize() {
        updateSliderFades(this);
      },
      update() {
        updateSliderFades(this);
      },
      touchEnd(swiper, event) {
        dataLayerPushSlider(swiper, event);
      },
    },
  });

  updateSliderFades(swiper);
  sliderEl._swiper = swiper;
}

function destroySwiper(sliderEl) {
  if (!sliderEl._swiper) return;

  sliderEl._swiper.destroy(true, true);
  sliderEl._swiper = null;
  sliderEl.classList.remove('au-benefits__slider--fade-left', 'au-benefits__slider--fade-right');
}

function updateSliderFades(swiper) {
  const el = swiper.el;
  const controls = el.querySelector('[data-au-slider-controls]');

  if (swiper.isLocked) {
    el.classList.remove('au-benefits__slider--fade-left', 'au-benefits__slider--fade-right');
    if (controls) controls.classList.add('au-hide');
    return;
  }

  if (controls) controls.classList.remove('au-hide');
  el.classList.toggle('au-benefits__slider--fade-left', !swiper.isBeginning);
  el.classList.toggle('au-benefits__slider--fade-right', !swiper.isEnd);
}

export default { init };
